<b3-modal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    [heading]="viewModel.title"
    aria-level="2"
    [icon]="viewModel.icon"
    [icon-tone]="viewModel.iconTone"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="credit-register-info-modal__text">{{ viewModel.message }}</p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="credit-register-info-modal__footer">
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onConfirm()">
        Entendi
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
